<template>
  <div>
    <Table
      :columns="columns"
      :data="serialResources"
      size="small"
      :loading="loading"
      highlight-row
      stripe
      max-height="700"
    >
      <template slot-scope="{ row }" slot="serial">
        <span
          class="ts-cursor-pointer text-primary ts-font-bold"
          v-clipboard:copy="row.serial_no"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          v-tooltip="copied"
          >{{ row.serial_no }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="group">
        {{
          row.product
            ? row.product.group
              ? row.product.group.pro_group_name_en
              : null
            : null
        }}
      </template>
      <template slot-scope="{ row }" slot="productName">
        {{ row.product ? row.product.product_name_en : null }}
      </template>
      <template slot-scope="{ row }" slot="status">
        <span :class="getStatusClasses(row.sn_status)">{{
          row.sn_status
        }}</span>
      </template>
      <template slot-scope="{ row }" slot="productName">
        {{ row.product ? row.product.product_name_en : null }}
      </template>
      <template slot-scope="{ row }" slot="originalWarehouse">
        {{
          row.stock_in
            ? row.stock_in.location
              ? row.stock_in.location.location_name_en
              : ''
            : ''
        }}
      </template>
      <template slot-scope="{ row }" slot="cost">
        <span class="ts-font-semibold ts-text-blue-600">
          {{ row.cost ? $defaultCurrencyWithCode(row.cost) : '' }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="additionalCost">
        <span class="ts-font-semibold ts-text-red-600">
          {{
            row.repair_cost ? $defaultCurrencyWithCode(row.repair_cost) : ''
          }}</span
        >
      </template>
      <template slot-scope="{ row }" slot="sparepartCost">
        <span class="ts-font-semibold ts-text-red-600">
          {{
            row.sparepart_cost ? $defaultCurrencyWithCode(row.sparepart_cost) : ''
          }}</span
        >
      </template>
      <template slot-scope="{ row }" slot="frameCode">
        <span
          class="ts-cursor-pointer text-primary ts-font-bold"
          v-clipboard:copy="row.imei"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          v-tooltip="copied"
          >{{ row.imei }}
        </span>
      </template>
      <template slot-scope="{ row }" slot="actions">
        <div
          class="ts-whitespace-no-wrap ts-py-2 ts-px-3 ts-text-center ts-space-x-3"
        >
          <a
            href="#"
            v-tooltip="$t('productProfile.uploadPhoto')"
            @click.prevent="attachFile(row)"
            class="text-secondary"
            :class="{
              'text-success': row.serial_photo.length > 0
            }"
          >
            <i v-if="row.serial_photo.length > 0" class="fas fa-images"></i>
            <i v-else class="fas fa-image"></i>
          </a>
          <a
            href="#"
            v-tooltip="$t('productProfile.viewHistory')"
            @click.prevent="showHistory(row)"
            ><i class="fas fa-eye text-info"></i
          ></a>
          <a
            href="#"
            v-if="row.allow_edit && row.sn_status_id !== 5"
            v-tooltip="$t('productProfile.editImei')"
            @click.prevent="updateImei(row)"
            ><i class="fas fa-edit"></i
          ></a>
        </div>
      </template>
    </Table>
    <a-modal
      v-if="show_history_serial"
      v-model="show_history_serial"
      :title="$t('productProfile.viewHistory')"
      :zIndex="1020"
      :footer="null"
      :maskClosable="false"
      width="70%"
    >
      <ts-loading-banner :loading="show_history_serial_waiting">
        <ViewSerialHistory
          :record="history"
          :movementHistory="movementHistory"
        />
      </ts-loading-banner>
    </a-modal>
    <a-modal
      v-if="show_upload_photo"
      v-model="show_upload_photo"
      :title="$t('productProfile.serialPhoto')"
      :zIndex="1020"
      :footer="null"
      :maskClosable="false"
      width="50%"
    >
      <ts-loading-banner :loading="show_upload_photo_waiting">
        <div class="ts-bg-gray-100 ts-mb-3">
          <h5 class="ts-p-2">Serial: {{ photos.serial_no }}</h5>
        </div>
        <form class="form-horizontal">
          <fieldset>
            <legend>{{ $t('productProfile.attachmentFile') }}</legend>
            <UploadPhoto v-model="model" :photos="photos" />
          </fieldset>
        </form>
        <div class="ts-flex ts-text-right ts-mt-4">
          <div class="col-md-12 ts-space-x-2 ts-flex ts-justify-end">
            <ts-button @click.prevent="onCancel">{{ $t('cancel') }}</ts-button>
            <ts-button
              color="primary"
              v-if="!isUpdate"
              :waiting="waiting"
              :disabled="!isAllUploaded || model.attach_file_list.length == 0"
              @click.prevent="savePhoto"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isUpdate"
              color="primary"
              :disabled="!isAllUploaded || model.attach_file_list.length == 0"
              @click.prevent="onUpdate"
              :waiting="waiting"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </ts-loading-banner>
    </a-modal>
    <a-modal
      v-if="show_modal_update_imei_serial"
      v-model="show_modal_update_imei_serial"
      :title="$t('productProfile.editImei')"
      :zIndex="1020"
      :maskClosable="false"
      :okText="$t('save')"
      :cancelText="$t('cancel')"
      :confirmLoading="waiting_update"
      @ok="onSetImei"
      width="700px"
    >
      <CarUpdateSerial
        v-model="model"
        :show_modal_update_imei_serial="show_modal_update_imei_serial"
        :waiting_update="waiting_update"
        :errors="errors"
        :update_imei_loading="update_imei_loading"
      ></CarUpdateSerial>
    </a-modal>
  </div>
</template>
<script>
import ViewSerialHistory from './view-serial-history.vue'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import UploadPhoto from './upload-photo.vue'
import CarUpdateSerial from './car-update-serial.vue'
export default {
  name: 'CarSerialTable',
  components: {
    ViewSerialHistory,
    UploadPhoto,
    CarUpdateSerial
  },
  props: ['model', 'serialResources', 'fetchData'],
  data() {
    return {
      copied: 'Click to copy serial',
      src: null,
      show_pdf: false,
      loading: false,
      waiting_update: false,
      waiting: false,
      update_imei_loading: false,
      sn_status_id: [1],
      location_id: [],
      history: [],
      movementHistory: [],
      show_history_serial: false,
      show_modal_update_imei_serial: false,
      show_history_serial_waiting: false,
      show_upload_photo_waiting: false,
      show_upload_photo: false,
      errors: new Errors(),
      employees: [],
      employeeResources: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('productProfile.serial'),
          slot: 'serial',
          fixed: 'left',
          width: 150
        },
        {
          title: this.$t('productProfile.group'),
          slot: 'group',
          width: 120
        },
        {
          title: this.$t('productProfile.productName'),
          slot: 'productName',
          width: 200
        },
        {
          title: this.$t('productProfile.pi#'),
          key: 'stock_in_number',
          width: 150
        },
        {
          title: this.$t('productProfile.piDate'),
          key: 'stock_in_date',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('productProfile.color'),
          key: 'color',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('productProfile.frameCode'),
          slot: 'frameCode',
          fixed: 'left',
          width: 180
        },
        {
          title: this.$t('productProfile.plateNumber'),
          key: 'plate_number',
          width: 150
        },
        {
          title: this.$t('productProfile.cost'),
          slot: 'cost',
          align: 'right',
          width: 100
        },
        {
          title: this.$t('productProfile.additionalCost'),
          slot: 'additionalCost',
          className: 'repairCost',
          align: 'right',
          width: 150
        },
        {
          title: this.$t('productProfile.sparepartCost'),
          slot: 'sparepartCost',
          align: 'right',
          width: 150
        },
        {
          title: this.$t('productProfile.engineNumber'),
          key: 'engine_number',
          width: 180
        },
        {
          title: this.$t('productProfile.mcNumber'),
          key: 'mc_number',
          width: 150
        },
        {
          title: this.$t('productProfile.originalWarehouse'),
          slot: 'originalWarehouse',
          width: 200
        },
        {
          title: this.$t('productProfile.warehouse'),
          key: 'location_name_en',
          width: 200
        },
        {
          title: this.$t('productProfile.status'),
          slot: 'status',
          align: 'center',
          fixed: 'right',
          width: 100
        },
        {
          title: this.$t('productProfile.saleInvoiceNumber'),
          key: 'invoice_no',
          width: 150
        },
        {
          title: this.$t('productProfile.saleInvoiceDate'),
          key: 'stock_out_date',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('productProfile.remark'),
          key: 'qc_remarks',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'actions',
          fixed: 'right',
          align: 'center',
          className: 'ts-space-x-2',
          width: 120
        }
      ]
    },
    company_id() {
      return this.$store.state.authUser.user.default_branch.company_id
    },
    ...mapState('product/profile', [
      'serialPagination',
      'serialStatus',
      'edit_data',
      'colors',
      'steeringWheels',
      'remarks'
    ]),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
    isAllUploaded() {
      const allFiles = this.model.attach_file_list.length

      const uploadedFile = this.model.attach_file_list.filter(
        u => u.uploaded === true
      )

      return allFiles == uploadedFile.length
    },
    warehouse() {
      return this.$store.state.product.profile.warehouses.map(el => ({
        value: el.location_id,
        label: el.location_name_en,
        is_default: el.pivot.is_default
      }))
    }
  },
  methods: {
    ...mapActions('product/profile', [
      'fetchSerialStatus',
      'fetchSerialHistory',
      'setImei',
      'employee',
      'getColor',
      'getSteeringWheel',
      'getRemark',
      'formViewModel'
    ]),
    getStatusClasses(status) {
      const statusClasses = {
        'In storage': 'badge badge-info',
        'Available for Sale': 'badge badge-primary',
        Sold: 'badge badge-success',
        'Write-off': 'badge badge-danger',
        'Return to Vender': 'badge badge-warning',
        'QC and Repairing': 'badge badge-secondary'
      }

      return statusClasses[status] || 'text-default'
    },
    showHistory(record) {
      this.show_history_serial = true
      this.show_history_serial_waiting = true
      this.history = []
      this.fetchSerialHistory(record.serial_no)
        .then(response => {
          this.history = response.data
          this.movementHistory = response.movementHistory
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.show_history_serial_waiting = false
        })
    },
    async updateImei(record) {
      this.errors = new Errors()
      this.show_modal_update_imei_serial = true
      this.update_imei_loading = true
      await Promise.all([this.fetchEmployee(), this.getRemark()])
      this.model.serial_no = record.serial_no
      this.model.qc_remarks = record.qc_remarks
      this.model.qc_by = record.qc_by
      this.model.imei = record.imei
      this.model.product_grade = record.product_grade
      this.model.cost = record.cost
      this.model.color = record.color
      this.model.plate_number = record.plate_number
      this.model.mc_number = record.mc_number
      this.model.year_of_m = record.year_of_m
      this.model.engine_number = record.engine_number
      this.model.steering_wheel = record.steering_wheel
      this.model.vehicle_registration_date = record.vehicle_registration_date
      this.model.issued_by = record.issued_by
      this.ensureCurrentRemarkInList(record.qc_remarks)
      this.update_imei_loading = false
    },
    onSetImei() {
      this.waiting_update = true
      this.src = null
      this.errors = new Errors()
      this.setImei(this.model)
        .then(response => {
          this.show_pdf = true
          this.src = response.url
          this.show_modal_update_imei_serial = false
          this.$emit('refresh-data')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_update = false
        })
    },
    fetchEmployee() {
      this.update_imei_loading = true
      this.employee()
        .then(async response => {
          this.employees = response.data
          await this.formViewModel({
            fnName: 'productGrade'
          }).then(({ data }) => {
            this.grades = data.productGrade
          })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.update_imei_loading = false
        })
    },
    handleSearchEmployee(value) {
      let em = this.employees.find(em => em.card_id == value)
      if (em) {
        this.model.qc_by = em.employee_id
      }
    },
    attachFile(items) {
      this.show_upload_photo = true
      this.photos = items
    },

    savePhoto() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch(
          'product/profile/storePhoto',
          Object.assign({}, this.model, {
            serial_no: this.photos.serial_no
          })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.onCancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onCancel() {
      this.show_upload_photo = false
      this.fetchData()
    },
    clearEdit() {
      this.showForm = false
    },
    ensureCurrentRemarkInList(currentRemark) {
      if (currentRemark && !this.remarks.some(r => r.qc_remarks === currentRemark)) {
        this.remarks.push({ qc_remarks: currentRemark })
      }
    },
    onCopy: function(e) {
      this.copied = 'Copied'
      setTimeout(() => {
        this.copied = 'Click to copy serial'
      }, 1000)
    },
    onError: function(e) {
      this.copied = 'Failed Copied'
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchSerialStatus()
      vm.getColor()
      vm.getSteeringWheel()
      vm.getRemark()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/profile/SET_RESET_SERIAL_PAGE')
    this.$store.commit('product/profile/RESET_RESOURCES_SERIAL')
    next()
  }
}
</script>
